var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 971.56 481.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .e, .f, .g {\n        stroke-width: 0px;\n      }\n\n      .h {\n        clip-path: url(#d);\n      }\n\n      .f {\n        fill: none;\n      }\n\n      .g {\n        fill: #f2e855;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "971.56 426.5 956.22 481.78 0 55.28 15.34 0 971.56 426.5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 854.18,
    y: 209.45,
    width: 37.64,
    height: 927.19,
    transform: "translate(663.87 1755.34) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 837.27,
    y: 175.82,
    width: 37.64,
    height: 927.19,
    transform: "translate(669.41 1691.5) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 820.37,
    y: 142.19,
    width: 37.64,
    height: 927.19,
    transform: "translate(674.95 1627.66) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 803.46,
    y: 108.56,
    width: 37.64,
    height: 927.19,
    transform: "translate(680.49 1563.82) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 786.55,
    y: 74.94,
    width: 37.64,
    height: 927.19,
    transform: "translate(686.03 1499.98) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 769.64,
    y: 41.31,
    width: 37.64,
    height: 927.19,
    transform: "translate(691.57 1436.14) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 752.73,
    y: 7.68,
    width: 37.64,
    height: 927.19,
    transform: "translate(697.11 1372.3) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 735.82,
    y: -25.95,
    width: 37.64,
    height: 927.19,
    transform: "translate(702.65 1308.46) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 718.91,
    y: -59.58,
    width: 37.64,
    height: 927.19,
    transform: "translate(708.19 1244.62) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 702.01,
    y: -93.2,
    width: 37.64,
    height: 927.19,
    transform: "translate(713.73 1180.78) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 685.09,
    y: -126.85,
    width: 37.64,
    height: 927.19,
    transform: "translate(719.27 1116.9) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 668.18,
    y: -160.48,
    width: 37.64,
    height: 927.19,
    transform: "translate(724.81 1053.06) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 651.27,
    y: -194.11,
    width: 37.64,
    height: 927.19,
    transform: "translate(730.35 989.22) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 634.36,
    y: -227.73,
    width: 37.64,
    height: 927.19,
    transform: "translate(735.89 925.38) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 617.45,
    y: -261.36,
    width: 37.64,
    height: 927.19,
    transform: "translate(741.43 861.54) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 466.05,
    y: -227.35,
    width: 37.64,
    height: 927.19,
    transform: "translate(491.62 775.56) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 449.14,
    y: -260.98,
    width: 37.64,
    height: 927.19,
    transform: "translate(497.16 711.72) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 432.23,
    y: -294.6,
    width: 37.64,
    height: 927.19,
    transform: "translate(502.7 647.88) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 415.32,
    y: -328.23,
    width: 37.64,
    height: 927.19,
    transform: "translate(508.24 584.04) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 299.54,
    y: -312.01,
    width: 37.64,
    height: 927.19,
    transform: "translate(325.95 504.1) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 282.63,
    y: -345.64,
    width: 37.64,
    height: 927.19,
    transform: "translate(331.49 440.26) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 265.72,
    y: -379.27,
    width: 37.64,
    height: 927.19,
    transform: "translate(337.03 376.42) rotate(-116.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 248.81,
    y: -412.9,
    width: 37.64,
    height: 927.19,
    transform: "translate(342.57 312.58) rotate(-116.69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTape);
export default __webpack_public_path__ + "static/media/tape.e681e018a1688eed3f856a1e2d300030.svg";
export { ForwardRef as ReactComponent };